<template>
  <span
    class="meeting-item-col"
    v-if="agenda.callback_number && agenda.meeting_type === 'callback'"
  >
    <a
      :href="`tel:${agenda.callback_number}`"
      target="_blank"
      @click="copyToClipboard(agenda.callback_number || '')"
    >
      <button class="btn btn-sm btn-outline-primary">
        <i class="bi bi-telephone-fill me-1"></i>{{ agenda.callback_number }}
      </button>
    </a>
  </span>
  <span class="meeting-item-col btn text-primary p-0" v-if="agenda.meeting_type == 'in_person'">
    <i class="bi bi-people-fill me-1"></i>
    {{ agenda.room ? "Room " + agenda.room : "Unavailable" }}
  </span>
  <span class="meeting-item-col" v-if="agenda.meeting_type === 'virtual'">
    <ZoomLink
      :link="agenda[virtualData.property] || ''"
      v-if="virtualData.property === virtualTypes.zoom"
    ></ZoomLink>
    <GoogleMeetLink
      :link="agenda[virtualData.property]"
      v-else-if="virtualData.property === virtualTypes.google"
    ></GoogleMeetLink>
    <MicrosoftTeamsLink
      :link="agenda[virtualData.property]"
      v-else-if="virtualData.property === virtualTypes.teams"
    ></MicrosoftTeamsLink>
    <button
      class="btn btn-sm btn-outline-primary"
      v-else
      @click="joinVirtualMeeting(agenda[virtualData.property])"
    >
      <v-tooltip activator="parent" location="bottom" class="custom-tooltip">{{
        virtualData.title
      }}</v-tooltip>
      <i class="bi bi-play-fill me-1"></i>Join
    </button>
  </span>
</template>

<script setup lang="ts">
import type { ConferenceDay, GetSchedule } from "@/api_types/teacher";
import { copyToClipboard } from "@/utils";
import { getMeetingType, getMeetingUrlProperty, virtualTypes } from "@/utils/meetingTypes";
import { computed } from "vue";
import ZoomLink from "./zoomLink.vue";
import GoogleMeetLink from "./googleMeetLink.vue";
import MicrosoftTeamsLink from "./MicrosoftTeamsLink.vue";
import FetchService from "@/services/fetch.service";

const props = defineProps<{
  agenda: GetSchedule;
  conferenceDay: ConferenceDay;
  useAgendaTypes?: boolean;
}>();
const refreshVirtualDetails = async(pta_id) => {
      const details = {
        "pta_id": pta_id,
        "meeting_type": "virtual"
      };
      const resp = await FetchService.fetchData("/meetingdetail/" + pta_id, "put", details);
};
const virtualData = computed(() => {
  const label = getMeetingType(
      props.agenda.flag == "T" || props.useAgendaTypes
        ? props.agenda.meeting_types!
        : props.conferenceDay.teacher_meeting_types,
      props.agenda
    );
  if (label == 'Link generation in progress' && props.agenda.meeting_type == 'virtual'){
    // If the meeting type is set to virtual then the meeting link needs to be generated.
    console.log("Link generation still in progress...need to request a new link");
    console.log(props.agenda);
    refreshVirtualDetails(props.agenda.pta_id);
  }
  return {
    property: getMeetingUrlProperty(
      props.agenda.flag == "T" || props.useAgendaTypes
        ? props.agenda.meeting_types!
        : props.conferenceDay.teacher_meeting_types,
      props.agenda
    ),
    title: label
  };
});
console.log(virtualData.value);

function joinVirtualMeeting(link: string) {
  if (link) {
    if (!link.includes("http")) link = "https://" + link;
    window.open(link, "_blank");
  }
}


</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
